import type { LandingPageContextDto } from '@/types/landingPage'

export interface BrandMark {
    url: string
    alt: string
    className: string
    /** The background the version is made for, shown behind it whatever the dashboard's theme; null works on either. */
    ground: 'Light' | 'Dark' | null
}

// Every version of each mark the page was built with: one that works on either background, and the ones made for light
// or dark backgrounds (ORB-968). Each marked version is shown on its own ground, so it reads in either dashboard theme.
export function brandMarksOf(context: LandingPageContextDto): BrandMark[] {
    const kinds = [
        { name: 'logo', className: 'h-10 max-w-[180px] object-contain', either: context.LogoUrl, light: context.LogoUrlForLightBackgrounds, dark: context.LogoUrlForDarkBackgrounds },
        { name: 'icon', className: 'h-10 w-10 object-contain rounded', either: context.IconUrl, light: context.IconUrlForLightBackgrounds, dark: context.IconUrlForDarkBackgrounds },
        { name: 'banner', className: 'h-10 max-w-[200px] object-contain rounded', either: context.BannerUrl, light: context.BannerUrlForLightBackgrounds, dark: context.BannerUrlForDarkBackgrounds },
    ]
    return kinds.flatMap(({ name, className, either, light, dark }) => [
        either ? { url: either, alt: `Brand ${name}`, className, ground: null } : null,
        light ? { url: light, alt: `Brand ${name} for light backgrounds`, className, ground: 'Light' } : null,
        dark ? { url: dark, alt: `Brand ${name} for dark backgrounds`, className, ground: 'Dark' } : null,
    ].filter((mark): mark is BrandMark => mark !== null))
}
